import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavItemLink } from '../components/item/NavItem';
import styles from './nav_personas_buttons.module.scss';

export function NavPersonaLawyer() {
  return (
    <NavItemLink className={styles.container} href="/avocat" source="header">
      <FormattedMessage id="navigation/personas/NavPersonasButtons.tsx/1" />
    </NavItemLink>
  );
}

export function NavPersonaJuriste() {
  return (
    <NavItemLink className={styles.container} href="/juriste" source="header">
      <FormattedMessage id="navigation/personas/NavPersonasButtons.tsx/2" />
    </NavItemLink>
  );
}
